/* eslint-disable eqeqeq */

import { useState } from "react";
import Search from "../../assets/icons/Search";

const TableSearchInput = ({ column, columnFilterValue }) => {
  const [FilterText, setFilterText] = useState("");

  const handleSetData = (e) => {
    var { keyCode } = e;
    if (keyCode == "13") {
      column.setFilterValue(FilterText);
    }
  };

  return (
    <div className="relative w-fit h-fit mt-2">
      <div className="absolute left-0 top-1/2 -translate-y-1/2 ml-2">
        <Search />
      </div>
      <input
        type="text"
        className="px-8 py-2 rounded-[4px] border-0 bg-gray-background text-sm text-gray-dark_text outline-none placeholder:text-gray-place_text"
        placeholder="Search"
        onKeyUp={handleSetData}
        value={FilterText}
        onChange={(e) => setFilterText(e.target.value)}
      />
      {/* <div>{instance.getTableProps()}</div> */}
    </div>
  );
};

export default TableSearchInput;
